import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

//pics
import cardProfile1Square from "assets/img/nancy-holly.jpg";
import cardProfile2Square from "assets/img/vivian-hunt.jpg";
import dg2 from "assets/img/crowd2.jpg";

//icons
import FormatQuote from "@material-ui/icons/FormatQuote";

class TestimonialsSection extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    
    return (
      <div className="cd-section" {...rest}>
        <div
          className={`${classes.testimonials} ${classes.sectionImage}`}
          style={{ backgroundImage: `url(${dg2})` }}
        >
          <div className={classes.container}>
            <GridContainer>
              <GridItem
                xs={12}
                sm={6}
                md={6}
                className={`${classes.mlAuto} ${classes.mrAuto} ${
                  classes.textCenter
                }`}
              >
                <h2 className={classes.title}>Testimonials</h2>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={4} md={6}>
                <Card testimonial className={classes.card1}>
                  <div className={classes.icon}>
                    <FormatQuote />
                  </div>
                  <CardBody>
                    <h5 className={classes.cardDescription} style={{color:'#696969'}}>
                      "Thank you so much for making All Things E.Q. so easy and ready to implement for our staff and the community we serve! The techniques are highly effective. You bring such a refreshing touch to education.""
                      <br />
                    </h5>
                  </CardBody>
                  <CardFooter testimonial>
                    <h4 className={classes.cardTitle}>Nancy Holly</h4>
                    <h6 className={classes.cardCategory}>Reading Specialist, Arrowhead Elementary</h6>
                    
                    <CardAvatar testimonial testimonialFooter>
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img src={cardProfile1Square} alt="..." />
                      </a>
                    </CardAvatar>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={4} md={6}>
                <Card testimonial className={classes.card1}>
                  <div className={classes.icon}>
                    <FormatQuote />
                  </div>
                  <CardBody>
                    <h5 className={classes.cardDescription} style={{color:'#696969'}}>
                      "All Things E.Q. has positively impacted our students in a big way, and we have the data to prove it. According to the Gallup Poll, hope, engagement, and wellbeing have increased by ten points, and our referrals have decreased in number and severity."
                    </h5>
                  </CardBody>
                  <CardFooter testimonial>
                    <h4 className={classes.cardTitle}>Vivian Hunt</h4>
                    <h6 className={classes.cardCategory}>Principal, Arrowhead Elementary</h6>
                    <CardAvatar testimonial testimonialFooter>
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img src={cardProfile2Square} alt="..." />
                      </a>
                    </CardAvatar>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={4} md={6}>
                <Card testimonial className={classes.card1}>
                  <div className={classes.icon}>
                    <FormatQuote />
                  </div>
                  <CardBody>
                    <h5 className={classes.cardDescription} style={{color:'#696969'}}>
                      "All Things E.Q. has made a big difference in my parenting style. I really like the All Things E.Q platform and the emails are so fun to get! My son was diagnosed with ADD/ADHD and we have been struggling with homework and school in general all year.  The things you talk about in the All Things E.Q. emails have helped tremendously. Thanks for all you do!"
                    </h5>
                  </CardBody>
                  <CardFooter testimonial>
                    <h4 className={classes.cardTitle}>Melissa</h4>
                    <h6 className={classes.cardCategory}>Parent</h6>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={4} md={6}>
                <Card testimonial className={classes.card1}>
                  <div className={classes.icon}>
                    <FormatQuote />
                  </div>
                  <CardBody>
                    <h5 className={classes.cardDescription} style={{color:'#696969'}}>
                      "Let me start off by saying, I used to HATE doing the dishes. My motto was “Doing the dishes is boring and a waste of my time.” Then I changed my motto to “Doing the dishes is necessary and helpful to my mom, since she goes to nursing school.” Why have a negative motto about something you have to do every day? We all deserve an enjoyable life, don’t we?"
                      <br />
                    </h5>
                  </CardBody>
                  <CardFooter testimonial>
                    <h4 className={classes.cardTitle}>Emma Rogoveanu</h4>
                    <h6 className={classes.cardCategory}>5th Grade Student</h6>
                  </CardFooter>
                </Card>
              </GridItem>
              
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(testimonialsStyle)(TestimonialsSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionTestimonials.jsx